import { useFormikContext } from 'formik';

import { GenericStatusEnum, ThirdPartyTypeEnum } from '@e-socna/data-layer';

import { Loading } from '../../../../components/Loading';

import { ThirdPartiesSelectionFormStep } from '../../../ThirdParty/steps/Selection';

import { useUsersPersonIdsQuery } from '../../hooks/useUsersPersonIdsQuery.hook';
import type { UserFormValues } from '../../types/user-form-values.type';

interface Props {
  readonly id: string;
}

// eslint-disable-next-line no-empty-pattern
export const UserPersonSelectFormStep = ({}: Readonly<Props>) => {
  const { values } = useFormikContext<UserFormValues>();
  const { data, isSuccess } = useUsersPersonIdsQuery();

  if (!isSuccess) {
    return <Loading />;
  }

  return (
    <ThirdPartiesSelectionFormStep
      excludedIds={data.findAllUsers.map(({ personId }) => personId)}
      fieldName="personId"
      id="personId"
      isInternal={values.isInternal}
      kind={ThirdPartyTypeEnum.Person}
      status={GenericStatusEnum.Enabled}
    />
  );
};
